import React from 'react'

import { ColumnLayout } from '@/components'
import { ExperienceType } from '@/generated/graphql'
import { useLayoutSize } from '@/hooks/layout-size.hooks'

import { UserInfoAboutMe } from './user-info-about-me.component'
// import { UserInfoAchievements } from './user-info-achievements.component'
import { UserInfoBackground } from './user-info-background/user-info-background.component'
import { UserInfoHobby } from './user-info-hobby/user-info-hobby.component'
import { UserInfoOKR } from './user-info-okr.component'
// import { UserInfoProject } from './user-info-project.component'
import { UserInfoSkill } from './user-info-skill/user-info-skill.component'
import { UserInfoWorkCircle } from './user-info-work-circle.component'
import s from './user-info.module.less'

export const UserInfo: React.FC<{
  readonly?: boolean
  userId: number
  viewerId: number
  hasLeftBar?: boolean
}> = ({ userId, viewerId, readonly = true, hasLeftBar = false }) => {
  const { isMobileSize, isLeftMiddleSize } = useLayoutSize()

  const showOnlyMiddle = hasLeftBar ? isLeftMiddleSize : isMobileSize

  const rightComponent = (
    <>
      {/* <UserInfoAchievements userId={userId} /> */}
      <UserInfoSkill userId={userId} viewerId={viewerId} readonly={readonly} />
      <UserInfoHobby userId={userId} viewerId={viewerId} readonly={readonly} />
    </>
  )

  const middle = (
    <div className={s.containerInner}>
      <div className={s.userPageInfo}>
        <UserInfoAboutMe userId={userId} readonly={readonly} />
        {/* <UserInfoProject userId={userId} readonly={readonly} /> */}
        <UserInfoOKR userId={userId} readonly={readonly} viewerId={viewerId} />
        <UserInfoWorkCircle userId={userId} readonly={readonly} />
        <UserInfoBackground
          backgroundType={ExperienceType.Career}
          key={ExperienceType.Career}
          userId={userId}
          readonly={readonly}
        />
        <UserInfoBackground
          backgroundType={ExperienceType.Education}
          key={ExperienceType.Education}
          userId={userId}
          readonly={readonly}
        />
        {showOnlyMiddle && rightComponent}
      </div>
    </div>
  )

  const right = !showOnlyMiddle && <div className={s.sidebar}>{rightComponent}</div>

  const content = (
    <div className={s.userInfoContainer}>
      {middle}
      {right}
    </div>
  )

  return <ColumnLayout middle={content} />
}
